import { Action, Set } from 'src/state/types'
import { set } from 'src/state/utils'
import { action } from 'easy-peasy'

export interface Gong {
  _id: string
  slug: string
  short: { fr: string; en: string }
  image: string
  cover: string
}
export interface User {
  _id: string
  email: string
  level: number
  totalNaps: number
  totalMinutes: number
  gong?: Gong | null
}

export interface Preferences {
  locale?: 'fr' | 'en' | 'auto'
  hideAudioHelp?: boolean
  onboarded?: boolean
  gongAnnouncementShown?: boolean
}

interface ModelProfile {
  // State
  user: User | null
  preferences: Preferences | null

  // Actions
  setUser: Set<this, 'user'>
  setPreferences: Set<this, 'preferences'>
  updateUser: Action<this, Partial<NonNullable<this['user']>>>
  updatePreferences: Action<this, Partial<NonNullable<this['preferences']>>>
}

export const modelProfile: ModelProfile = {
  // State
  user: null,
  preferences: null,

  // Actions
  setUser: set('user'),
  setPreferences: set('preferences'),
  updateUser: action((state, payload) => {
    if (!state.user) {
      state.user = payload as ModelProfile['user']
    } else {
      Object.assign(state.user, payload)
    }
  }),
  updatePreferences: action((state, payload) => {
    if (!state.preferences) {
      state.preferences = payload as ModelProfile['preferences']
    } else {
      Object.keys(payload).forEach((k) => {
        const key = k as keyof ModelProfile['preferences']
        state.preferences![key] = payload[key]
      })
    }
  }),
}
